/**
 * Clean phone number input (allow only digits, spaces, and hyphens)
 */
export const cleanPhoneNumber = (value: string): string => {
  return value.replace(/[^\d\s-]/g, '')
}

/**
 * Format phone number for display (optional, can be extended)
 */
export const formatPhoneNumber = (
  value: string,
  countryCode?: string
): string => {
  // Basic formatting - can be extended with country-specific patterns
  const cleaned = cleanPhoneNumber(value)

  // For now, just return the cleaned value
  // Future: Add country-specific formatting patterns
  return countryCode ? `+${countryCode}${cleaned}` : cleaned
}
